<template>
  <div>
    <ConfirmModal
      msg="Are you sure you want to snooze the alarm"
      :show="showConfirm"
      heading="Snooze Alarm?"
      btnTxt="Yes, Snooze"
      @close="showConfirm = false"
      @submit="handleSnooze"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="$t('success_msg_alarm')"
      :heading="$t('success_heading_alarm')"
    />

    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <button
        class="btn btn-primary introjs m-2 mr-4 pt-1"
        @click="startIntroJs"
      >
        Tour<i class="font-16 text-warning ml-2 mdi mdi-lightbulb-on"></i>
      </button>
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center mb-2">
            <h6 class="font-16 font-weight-bold">
              {{ showAddAlarm ? $t("add_alm") : $t("alarms") }}
            </h6>
          </div>
          <div class="col-md-7 align-self-center">
            <div
              class="d-flex align-items-center justify-content-end col-gap-1"
            >
              <!-- <button
                @click="showConfirm = true"
                :disabled="alarmsIdsArray.length === 0"
                class="btn btn-secondary"
              >
                {{ $t("snooze_alarm") }}
              </button> -->
              <button
                @click="showAddAlarm = true"
                :disabled="showAddAlarm"
                class="btn btn-primary"
                v-if="!showAddAlarm"
              >
                {{ $t("add_alm") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <div class="succeed container-fluid" v-show="mssg !== ''">
          <p>{{ $t("notif_") }}</p>
          <p class="mb-2">{{ mssg }}</p>
        </div>

        <alarm-created
          :alarmsIdsArray="alarmsIdsArray"
          @alarm_clicked="handleAlarmClicked"
          @select_all="selectAllAlarms"
          v-if="!showAddAlarm"
        />
        <div class="card" v-else>
          <div class="card-body add-alarm-container">
            <div class="mb-3">
              <Stepper :step="step" :labels="labels" />
            </div>
            <add-alarm
              :step="step"
              @goBack="goBack"
              @goNext="goNext"
              @closeAddAlarm="showAddAlarm = false"
              @step="goStep"
            />
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- footer -->
      <!-- ============================================================== -->
      <!-- <footer class="footer text-center">
        All Rights Reserved by Gricd Frij.
      </footer> -->
      <!-- ============================================================== -->
      <!-- End footer -->
      <!-- ============================================================== -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import store from "../../store/index";
import introJs from "intro.js";
import "intro.js/introjs.css";
import Dropdown from "../../components/Dropdown";
import Stepper from "../../components/Stepper";
// import moment from 'moment';
import { ToggleButton } from "vue-js-toggle-button";
import { bus } from "../../main";
import AlarmCreated from "./AlarmCreated.vue";
import ConfirmModal from "../Modals/ConfirmModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import AddAlarm from "./AddAlarm.vue";

Vue.component("ToggleButton", ToggleButton);

export default {
  name: "Alarms",
  data() {
    return {
      all: false,
      isLoading: false,
      fullPage: true,
      isOpen: false,
      openDrop: false,
      openDrop2: false,
      toggleValue: "whatsapp",
      soundNotification: false,
      setEmailAdmin: false,
      emailAdmin: "",
      title: "",
      alarmType: "Temperature",
      device: [],
      selectedEmailList: [],
      selectedPhoneList: [],
      alarmValue: null,
      setSms: false,
      setWebhook: false,
      valueNotify: "",
      startdate: "",
      startime: "",
      enddate: "",
      endtime: "",
      mssg: "",
      Errormssg: "",
      webhook: "",
      name: "",
      whenStable: false,
      interval: 1 * 60,
      filteredDevices: [],
      key: "",
      deviceTest: [
        {
          name: this.$t("humid"),
        },
        {
          name: this.$t("temp"),
        },
        {
          name: this.$t("geo"),
        },
        {
          name: this.$t("batt"),
        },
      ],
      timeInterval: [
        { time: "5mins", val: 5 },
        { time: "15mins", val: 15 },
        { time: "30mins", val: 30 },
        { time: "45mins", val: 45 },
        { time: "1hr", val: 1 * 60 },
        { time: "2hrs", val: 2 * 60 },
        { time: "4hrs", val: 4 * 60 },
        { time: "6hrs", val: 6 * 60 },
        { time: "12hrs", val: 12 * 60 },
        { time: "24hrs", val: 24 * 60 },
      ],
      notifyOptions: [
        { name: this.$t("less_than"), val: "less" },
        { name: this.$t("grt_than"), val: "greater" },
      ],
      fenceNotificationOptions: [
        {
          name: this.$t("notif_geo"),
          id: "1",
          val: "in",
          type: "radio",
        },
        {
          name: this.$t("geo_notif_out"),
          id: "2",
          val: "out",
          type: "radio",
        },
        {
          name: this.$t("notif_geo_in_out"),
          id: "3",
          val: "in/out",
          type: "radio",
        },
      ],
      fenceOption: "",
      geofenceSelect: {},
      geofenceDevice: [],
      fenceId: "",
      edit: false,
      toggleEvent: false,
      showConfirm: false,
      showSuccessPopup: false,
      delEditOptions: false,
      valueError: "",
      selectNotification: "",
      alarmsIdsArray: [],
      showAddAlarm: false,
      labels: [
        this.$t("add_alarms"),
        this.$t("add_devices_users"),
        this.$t("summary"),
      ],
      step: 1,
    };
  },
  mounted() {
    // this.getalarms().then(() => {
    //   this.isLoading = false;
    // });
    this.fetchallDevices();
    this.getUsers();
    this.fetchGeofence();
    this.fetchPOI();
    this.filteredDevices = this.devices;
  },
  // beforeRouteEnter(to, from, next) {
  //   // Checks if the user is a staff
  //   if (store.getters.profile.role === "staff") {
  //     next(from);
  //   } else {
  //     next();
  //   }
  // },
  // beforeRouteLeave(to, from, next) {
  //   introJs().exit();
  //   next();
  // },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Loading,
    Dropdown,
    AlarmCreated,
    ConfirmModal,
    SuccessModal,
    Stepper,
    AddAlarm,
  },
  computed: {
    ...mapGetters(["alarms", "profile", "devices", "users", "geofence"]),
  },
  watch: {
    alarmValue: {
      handler: function() {
        if (
          this.alarmType == "Battery" &&
          (this.alarmValue < 0 || this.alarmValue > 100)
        ) {
          this.valueError = this.$t("valErr_batt");
        } else if (
          this.alarmType == "Battery" &&
          (this.alarmValue >= 0 || this.alarmValue <= 100)
        ) {
          this.valueError = "";
        }

        if (
          this.alarmType == "Temperature" &&
          (this.alarmValue < -100 || this.alarmValue > 100)
        ) {
          this.valueError = this.$t("valErr_temp");
        } else if (
          this.alarmType == "Temperature" &&
          (this.alarmValue >= -100 || this.alarmValue <= 100)
        ) {
          this.valueError = "";
        }

        // if (
        //   this.alarmType == 'Humidity' &&
        //   (this.alarmValue < -30 || this.alarmValue > 30)
        // ) {
        //   this.valueError = 'Value must be between -30°C to 30°C';
        // } else if (
        //   this.alarmType == 'Humidity' &&
        //   (this.alarmValue >= -30 || this.alarmValue <= 30)
        // ) {
        //   this.valueError = '';
        // }
        if (
          this.alarmType == "Humidity" &&
          (this.alarmValue < 0 || this.alarmValue > 100)
        ) {
          this.valueError = this.$t("valErr_humid");
        } else if (
          this.alarmType == "Humidity" &&
          (this.alarmValue >= 0 || this.alarmValue <= 100)
        ) {
          this.valueError = "";
        }
      },
    },
    soundNotification: {
      handler: function() {
        if (this.soundNotification) this.selectNotification = "";
      },
    },
    setEmailAdmin: {
      handler: function() {
        if (this.setEmailAdmin) this.selectNotification = "";
      },
    },
    setWebhook: {
      handler: function() {
        if (this.setWebhook) this.selectNotification = "";
      },
    },
    setSms: {
      handler: function() {
        if (this.setSms) this.selectNotification = "";
      },
    },
    device: {
      handler: function() {
        if (this.device >= 1) this.selectNotification = "";
      },
    },
    selectedPhoneList: {
      handler: function() {
        if (this.setSms && this.selectedPhoneList >= 1)
          this.selectNotification = "";
      },
    },
  },
  methods: {
    selectAllAlarms() {
      if (this.alarmsIdsArray.length === this.alarms.length) {
        this.alarmsIdsArray = [];
      } else this.alarmsIdsArray = this.alarms.map(({ id }) => id);
    },
    handleSnooze() {
      this.isLoading = true;
      this.snoozeAlarms()
        .then((res) => {
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
          bus.$emit("deleted", this.mssg);
          this.showDropdown = null;
          this.getalarms().then(() => {
            this.isLoading = false;
          });

          // if (res.data.status === 'success') {
          //   setTimeout(() => {
          //     this.isLoading = true;
          //   }, 1000);
          // }
          this.showSuccessPopup = true;
          this.showConfirm = false;
          this.setTimeout(() => {
            this.mssg = "";
          }, 4000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          bus.$emit("deleted", this.Errormssg);
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
    handleAlarmClicked(selectedId) {
      let temp = this.alarmsIdsArray;
      if (temp.includes(selectedId)) {
        temp = temp.filter((id) => id !== selectedId);
      } else temp.push(selectedId);
      this.alarmsIdsArray = temp;
    },
    onDeviceSelect(e) {
      if ([...this.device].includes(e)) {
        const index = this.device.indexOf(e);
        if (index > -1) {
          this.device.splice(index, 1);
        }
      } else this.device = [...this.device, e];
    },
    selectAll() {
      this.all = true;
      this.devices.forEach((item) => {
        if (this.device.includes(item.imei)) {
          return;
        } else this.device = [...this.device, item.imei];
      });
    },
    deSelectAll() {
      this.all = false;
      this.device = [];
      const test = document.getElementsByName("selected-device");
      test.forEach((item) => {
        if (item.checked) {
          item.checked = false;
        }
      });
    },

    doSearch() {
      let newData = [];
      newData = this.devices.filter((item) =>
        item.settings.name.toLowerCase().includes(this.key.toLowerCase())
      );
      this.filteredDevices = newData;
    },

    selectCheck(e) {
      if (this.device.includes(e)) {
        return true;
      } else return false;
    },
    handleToggleChange() {
      if (this.toggleValue === "sms") {
        this.toggleValue = "whatsapp";
      } else if (this.toggleValue === "whatsapp") {
        this.toggleValue = "sms";
      }
    },
    ...mapActions([
      "getalarms",
      "addValueAlarm",
      "addFenceAlarm",
      "fetchallDevices",
      "getUsers",
      "fetchGeofence",
      "deleteAlarm",
      "updateValueAlarm",
      "updateFenceAlarm",
      "snoozeAlarms",
      "fetchPOI",
    ]),
    onCancel() {
      this.isLoading = true;
      this.isOpen = false;
      this.name = "";
      this.startdate = "";
      this.startime = "";
      this.enddate = "";
      this.endtime = "";
      this.ErrorPhone = "";
      this.Errormssg = "";
      this.toggleValue = "whatsapp";
      this.soundNotification = false;
      this.setEmailAdmin = false;
      this.emailAdmin = "";
      this.title = "";
      this.alarmType = "Temperature";
      this.device = [];
      this.selectedEmailList = [];
      this.alarmValue = null;
      this.setSms = false;
      this.setWebhook = false;
      this.fenceOption = "";
      this.geofenceDevice = [];
      this.interval = 1 * 60;
      this.whenStable = false;
      this.showDropdown = null;
      this.edit = false;
      this.toggleEvent = false;
      this.id = "";
      this.delEditOptions = false;
      this.valueError = "";
      this.geofenceSelect = {};
      this.valueNotify = "";
      this.selectedPhoneList = [];
      this.key = "";
      this.deSelectAll();
      this.getalarms().then(() => {
        this.isLoading = false;
      });
    },
    closeModal() {
      this.isOpen = false;
      this.onCancel();
    },
    closeDropdown() {
      this.openDrop = false;
    },
    closeDropdown2() {
      this.openDrop2 = false;
    },
    startIntroJs() {
      introJs().start();
    },
    openModal() {
      this.isOpen = true;
      // introJs().exit();
    },
    // viewrecord(id) {
    //   this.$router.push(`records/${id}`);
    // },
    opendrop() {
      this.openDrop = !this.openDrop;
    },
    opendrop2() {
      this.openDrop2 = !this.openDrop2;
    },
    selectedEmails(e) {
      this.selectedEmailList = e;
    },
    selectedPhones(e) {
      this.selectedPhoneList = e;
    },
    onAlarmType(e) {
      this.alarmType = e.target.value;
      this.device = [];
      this.deSelectAll();
    },
    intervalTime(e) {
      this.interval = e.target.value;
    },
    updateUser(e) {
      this.selectedEmailList = [...this.selectedEmailList, e.target.value];
    },
    updategeofenceDevice() {
      console.log(this.geofenceSelect);
      this.geofenceDevice = [...this.geofenceDevice, this.geofenceSelect.name];
      this.fenceId = this.geofenceSelect.id;
    },
    goBack() {
      console.log("go back");
      if (this.step == 1) {
        this.showAddAlarm = false;
      } else this.step--;
    },
    goNext() {
      this.step++;
    },
    goStep(step) {
      this.step = step;
    },
  },
};
</script>

<style src="../../assets/css/style.css"></style>
<style scoped>
.introjs {
  /* background: none !important;
    height: 40px;
    width: 40px;
    padding: 0 !important;
    color: #213e7a !important;
    border-color: #213e7a !important; */
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
/* .introjs:hover{
      background: #213e7a !important;
      color: #fff !important;
    } */
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}
th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flex {
  display: flex;
}

.mylink {
  color: #494f54 !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
  text-underline-offset: 4px;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 4px;
}

/*
label.custom-control-label::before {
  content: 'On';
  font-size: 11px;
}
.custom-switch .custom-control-label::after {
  top: calc(0.15625rem + 0.25px);
  left: calc(-2.25rem + 49px);
  width: calc(1rem - -30px);
  height: calc(1rem - -3px);
  background-color: #afb5c1;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  content: blanchedalmond;
  width: 6.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
  height: auto;
  display: flex;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
} */
.top-select {
  padding-right: 1rem;
  background-color: #f9fafb;
}
.top-select span {
  padding: 0.1rem 2rem;
}
.device-select {
  border: solid 1px lightgrey;
}
.top-select i {
  align-self: center;
  margin-left: auto;
}
.check-devices input {
  margin-top: auto;
  margin-bottom: auto;
}
.devices {
  max-height: 5.3rem;
}
.outter {
  padding-left: 1.8rem;
}
.succeed {
  background: #dee2eb;
  padding: 10px 15px 1px;
  border: 1px solid #213e7a;
  margin-bottom: 2rem;
}
.succeed p {
  color: #213e7a;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 1px;
  z-index: 2;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}

@media (min-width: 768px) {
  .add-alarm-container {
    padding: 20px 2rem;
  }
}

@media (min-width: 1600px) {
  .add-alarm-container {
    padding: 40px 3rem;
  }
}
/* @media (min-width: 1600px) {
  .add-alarm-container {
    padding: 0 2rem;
  }
} */
</style>

<i18n>
{
	"en": {
		"add_alm": "Add Alarm",
		"add_user": "Add users / staff email",
		"all_alm": "All Alarms",
		"alm_type": "Type of Alarm",
		"alrm_title": "Alarm Name",
		"cancel": "Cancel",
		"desel_all": "Deselect all",
		"dev_bck": "Device {name} is back to normal",
		"devices": "Devices",
		"geo": "Geofence",
		"geo_dev": "Select Geofence",
		"geo_poi": "",
		"grt": "greater",
		"grt_than": "Greater than",
		"hist": "History",
		"less": "less",
		"less_than": "Less than or equal to",
		"no_dev_found": "No Device Found",
		"notif_": "Notification!",
		"notif_geo": "Notify when device is in/within Geofence",
		"notif_geo_in_out": "Notify when device is In/Out Geofence",
		"notif_geo_out": "Notify when device is out of Geofence",
		"notif_opt_sel": "Notification Option (Select all that apply)",
		"notif_poi": "Notify when device is in/within POI",
		"notif_poi_out": "Notify when device is out of POI",
		"notif_type": "Notification Type",
		"notif_wen": "Notify when",
		"opt_desc": "Description (Optional)",
		"poi_dev": "Select POI",
		"sel_all": "Select all",
		"sel_at_1": "Select at least one device",
		"sel_nofif_1": "Select at least one Notification option",
		"sel_notif_1": "Select at least one notification option",
		"sel_phone_1": "Select at least one phone number for sms",
		"select_alert": "Please select whether you want to be alerted based on the device per time period",
		"sms": "SMS",
		"the_url": "The URL you would like event data to be posted to",
		"time_int": "Time Interval",
		"upd_alm": "Update Alarm",
		"val": "Value",
		"valErr_batt": "Value must be between 0% to 100%",
		"valErr_humid": "Value must be between 0% to 100%",
		"valErr_temp": "Value must be between -30°C to 30°C",
		"view_alm": "View Alarms Created",
		"web_notif": "Webhook Notification"
	},
	"es": {
		"add_alm": "Agregar alarma",
		"add_user": "Agregar correo electrónico de usuarios / personal",
		"all_alm": "Todas las alarmas",
		"alm_type": "Tipo de alarma",
		"alrm_title": "Título de la alarma",
		"cancel": "Cancelar",
		"desel_all": "Deseleccionar todo",
		"dev_bck": "El dispositivo {name} volvió a la normalidad",
		"devices": "Dispositivos",
		"geo": "Geofence",
		"geo_dev": "Dispositivo de geovalla",
		"grt": "mayor",
		"grt_than": "mas grande que",
		"hist": "historia",
		"less": "menos",
		"less_than": "Menos que o igual a",
		"no_dev_found": "Ningún dispositivo encontrado",
		"notif_": "¡Notificación!",
		"notif_geo": "Notificar cuando el dispositivo esté dentro de la geovalla",
		"notif_geo_in_out": "Notificar cuando el dispositivo esté dentro / fuera de geovalla",
		"notif_geo_out": "Notificar cuando el dispositivo está fuera de Geofence",
		"notif_opt_sel": "Opción de notificación (seleccione todas las que correspondan)",
		"notif_poi": "Notificar cuando el dispositivo esté dentro de la POI",
		"notif_poi_out": "Notificar cuando el dispositivo está fuera de POI",
		"notif_type": "tipo de notificación",
		"notif_wen": "Notificar cuando",
		"opt_desc": "Descripción (opcional)",
		"poi_dev": "Seleccionar punto de interés",
		"sel_all": "Seleccionar todo",
		"sel_at_1": "Seleccione al menos un dispositivo",
		"sel_nofif_1": "Seleccione al menos una opción de notificación",
		"sel_notif_1": "Seleccione al menos una opción de notificación",
		"sel_phone_1": "Seleccione al menos un número de teléfono para sms",
		"select_alert": "Seleccione si desea recibir una alerta según el dispositivo por período de tiempo",
		"sms": "SMS",
		"the_url": "La URL en la que desea que se publiquen los datos del evento.",
		"time_int": "intervalo de tiempo",
		"upd_alm": "Actualizar alarma",
		"val": "Valor",
		"valErr_batt": "El valor debe estar entre 0% y 100%",
		"valErr_humid": "El valor debe estar entre 0% y 100%",
		"valErr_temp": "El valor debe estar entre -30 ° C y 30 ° C",
		"view_alm": "Ver alarmas creadas",
		"web_notif": "Notificación de webhook"
	},
	"fr": {
		"add_alm": "Ajouter une alarme",
		"add_user": "Ajouter des utilisateurs / e-mail du personnel",
		"all_alm": "Toutes les alarmes",
		"alm_type": "Type d'alarme",
		"alrm_title": "Titre de l'alarme",
		"cancel": "annuler",
		"desel_all": "Tout déselectionner",
		"dev_bck": "L'appareil {name} est revenu à la normale",
		"devices": "Dispositifs",
		"geo": "Geofence",
		"geo_dev": "Dispositif de clôture géographique",
		"geo_poi": "",
		"grt": "plus grand",
		"grt_than": "Plus grand que",
		"hist": "L'histoire",
		"less": "moins",
		"less_than": "Inférieur ou égal à",
		"no_dev_found": "Aucun appareil trouvé",
		"notif_": "Notification!",
		"notif_geo": "Avertir lorsque l'appareil est dans Geofence",
		"notif_geo_in_out": "Avertir lorsque l'appareil est In/Out Geofence",
		"notif_geo_out": "Avertir lorsque l'appareil est hors de Geofence",
		"notif_opt_sel": "Option de notification (Sélectionnez tout ce qui s'applique)",
		"notif_poi": "Avertir lorsque l'appareil est dans POI",
		"notif_poi_out": "Avertir lorsque l'appareil est hors de POI",
		"notif_type": "type de notification",
		"notif_wen": "Avertir quand",
		"opt_desc": "description (facultatif)",
		"poi_dev": "Sélectionnez PI",
		"sel_all": "Tout sélectionner",
		"sel_at_1": "Sélectionnez au moins un appareil",
		"sel_nofif_1": "Sélectionnez au moins une option de notification",
		"sel_notif_1": "Sélectionnez au moins une option de notification",
		"sel_phone_1": "Sélectionnez au moins un numéro de téléphone pour les SMS",
		"select_alert": "Veuillez sélectionner si vous souhaitez être alerté en fonction de l'appareil par période",
		"sms": "SMS",
		"the_url": "L'URL sur laquelle vous souhaitez que les données de l'événement soient publiées",
		"time_int": "Intervalle de temps",
		"upd_alm": "Mettre à jour l'alarme",
		"val": "Valeur",
		"valErr_batt": "La valeur doit être comprise entre 0% et 100%",
		"valErr_humid": "La valeur doit être comprise entre 0% et 100%",
		"valErr_temp": "La valeur doit être comprise entre -30°C et 30°C",
		"view_alm": "Afficher les alarmes créées",
		"web_notif": "Notification de webhook"
	},
	"sw": {
		"add_alm": "Ongeza Kengele",
		"add_user": "Ongeza barua pepe za watumiaji / wafanyikazi",
		"all_alm": "Kengele Zote",
		"alm_type": "Aina ya Kengele",
		"alrm_title": "Kichwa cha Kengele",
		"cancel": "Ghairi",
		"desel_all": "Usichague zote",
		"dev_bck": "Kifaa {name} kimerejea katika hali ya kawaida",
		"devices": "Vifaa",
		"geo": "Geofence",
		"geo_dev": "Chagua Geofence",
		"geo_poi": "",
		"grt": "kubwa zaidi",
		"grt_than": "Kubwa kuliko",
		"hist": "Historia",
		"less": "Kidogo",
		"less_than": "Chini ya au sawa na",
		"no_dev_found": "Hakuna Kifaa Kilichopatikana",
		"notif_": "Arifa!",
		"notif_geo": "Arifu wakati kifaa kiko/ndani ya Geofence",
		"notif_geo_in_out": "Arifu wakati kifaa kiko ndani/nje ya Geofence",
		"notif_geo_out": "Arifu wakati kifaa kiko nje ya Geofence",
		"notif_opt_sel": "Chaguo la Arifa (Chagua zote zinazotumika)",
		"notif_poi": "Arifu wakati kifaa kiko/ndani ya POI",
		"notif_poi_out": "Arifu wakati kifaa kimeisha POI",
		"notif_type": "Aina ya Arifa",
		"notif_wen": "Arifu lini",
		"opt_desc": "Maelezo (Si lazima)",
		"poi_dev": "Chagua POI",
		"sel_all": "Chagua Zote",
		"sel_at_1": "Chagua angalau kifaa kimoja",
		"sel_nofif_1": "Chagua angalau chaguo moja la Arifa",
		"sel_notif_1": "Chagua angalau chaguo moja la Arifa",
		"sel_phone_1": "Chagua angalau nambari moja ya simu kwa sms",
		"select_alert": "Tafadhali chagua kama ungependa kuarifiwa kulingana na kifaa kwa muda",
		"sms": "sms",
		"the_url": "URL ambayo ungependa data ya tukio ichapishwe",
		"time_int": "Muda wa Muda",
		"upd_alm": "Sasisha Kengele",
		"val": "Thamani",
		"valErr_batt": "Thamani lazima iwe kati ya 0% hadi 100%",
		"valErr_humid": "Thamani lazima iwe kati ya 0% hadi 100%",
		"valErr_temp": "Thamani lazima iwe kati ya -30°C hadi 30°C",
		"view_alm": "Tazama Kengele Zilizoundwa",
		"web_notif": "Arifa ya Mtandao"
	}
}
</i18n>
